import getOcTheme from '../../theme/services/getOcTheme';

const { palette, shape, typography } = getOcTheme();

export default {
  '& .ace-monokai': { background: 'transparent' },

  '& pre': {
    margin: '1rem 0 1rem',
    position: 'relative',
    color: palette.text.onMain,
    overflow: 'auto',

    '& code, & samp': {
      lineHeight: 1.5,
      whiteSpace: 'pre',
      color: palette.text.onContrasted,
      display: 'block',
      padding: 1,
      borderRadius: shape.borderRadius,
    },

    '& samp': {
      backgroundColor: palette.background.secondary,
      whiteSpace: 'inherit',
      overflow: 'scroll',
    },

    '& code': {
      position: 'relative',
      backgroundColor: '#282a36',

      '&[data-claire-semantic]::before': {
        ...typography.caption,
        content: 'attr(data-claire-semantic)',
        color: palette.text.onMain,
        position: 'absolute',
        top: '-1rem',
        right: 0,
      },

      '& .ace_comment': { color: '#c8cad0' },
    },

    '&:empty': { display: 'none' },

    '& + pre': { marginTop: '40px' },
  },

  '& * > code': {
    wordWrap: 'break-word',
    background: 'rgba(0, 0, 0, 0.04)',
    padding: '1px 5px',
    border: '1px solid rgba(0, 0, 0, 0.09)',
    display: 'inline-block',
  },
};
